import { styled, Tooltip, Typography } from '@mui/material'

interface TruncatedTextWithTooltipProps {
  text: string
  color: string
  fontSize: number
  fontWeight?: number
}

const TruncatedTextWithTooltip: React.FC<TruncatedTextWithTooltipProps> = ({
  text,
  color,
  fontSize,
  fontWeight,
}) => {
  const TruncatedText = styled(Typography)`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
    text-transform: capitalize;
    font-size: ${fontSize}px;
    font-weight: ${fontWeight ? fontWeight : 400};
  `

  return (
    <Tooltip
      title={text}
      color={color}
      arrow
      componentsProps={{
        tooltip: {
          sx: {
            textTransform: 'capitalize',
            fontSize: `${fontSize}px`,
          },
        },
      }}
    >
      <TruncatedText variant='body1'>{text}</TruncatedText>
    </Tooltip>
  )
}

export default TruncatedTextWithTooltip
